import { range } from 'helpers';
import { Box, Skeleton, Stack } from 'libs/ui';

export const SkeletonOrder = () => (
  <Stack spacing={32}>
    {range(5).map((index) => (
      <Stack key={index} spacing={24}>
        <Skeleton animation="wave" height={30} variant="rounded" width="30%" />
        <Stack direction="row" justifyContent="space-between" spacing={24}>
          <Box flex={1}>
            <Skeleton animation="wave" height={150} variant="rounded" />
          </Box>
          <Box flex={1}>
            <Skeleton animation="wave" height={150} variant="rounded" />
          </Box>
          <Box flex={1}>
            <Skeleton animation="wave" height={150} variant="rounded" />
          </Box>
        </Stack>
      </Stack>
    ))}
  </Stack>
);
